import React, { useState } from 'react';
import "./Home.css";
import { Link } from "react-router-dom";
import PetParentInfo from "./components/PetParentInfo";
import BillingInfo from "./components/BillingInfo";
import ViewClaimStatusInfo from "./components/view-claim-status/ViewClaimStatusInfo";
import LiveChat from "../common/live-chat/LiveChat.js";
import { AppLinks } from '../../constants/app-links';
import ModalDialog from "../common/modal-dialog-ml/ModalDialogML.js";
import CAPrivacyContent from "./CAPrivacyPolicyPopup.js";
import PrivacyContent from "./PrivacyPolicyPopup.js";

const Home = ({ userDetails, claimsDetails, enableRAF }) => {

    //CA Modal control
    const [isCAModalOpen, setIsCAModalOpen] = useState(false);

    const openCAModal = () => {
        setIsCAModalOpen(true);
    };

    const closeCAModal = () => {
        setIsCAModalOpen(false);
    };

    // Privacy Modal control
    const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);

    const openPrivacyModal = () => {
        setIsPrivacyModalOpen(true);
    };

    const closePrivacyModal = () => {
        setIsPrivacyModalOpen(false);
    };
    return (
        <div className="container-fluid">
            <div className="d-md-block container home" >
                <div className="links d-flex flex-row row flex-wrap" >
                    <div className="col-md-4 mb-4 list-container" >
                        <Link to={AppLinks.claims.fileClaim} >
                            <div className="home-list-box" >
                                <div><img className="home-list-icons claim-icon" src="/assets/images/icon-file-claim.svg" alt="File a Claim" /></div>
                                <div className="home-list-title col-9" >File a Claim</div>
                                <div><i className="fa fa-angle-right fa-2x text-secondary-angle " /></div>
                            </div>
                        </Link>
                    </div>
                   
                    { (userDetails.Status.toLowerCase().trim() === "cancel prorata" ||
                        userDetails.Status.toLowerCase().trim() === "cancel full")?null:(<div className="col-md-4 mb-4 list-container">
                        <Link to={AppLinks.account.updateBillingInfo} >
                            <div className="home-list-box">
                                <div><img className="manage-icon" src="/assets/images/dollar_icon.svg" /></div>
                                <div className="home-list-title col-9" >Manage Payments</div>
                                <div><i className="fa fa-angle-right fa-2x text-secondary-angle " /></div>
                            </div>
                        </Link>
                    </div>)}

                    <div className="col-md-4 mb-4 d-none d-md-block list-container" >
                        <Link to={AppLinks.claims.uploadMedicalRecords} >
                            <div className="home-list-box" >
                                <div><img className="home-list-icons" src="/assets/images/icon-upload-mr.svg" alt="Upload Medical Records" /></div>
                                <div className="home-list-title col-9" >Upload Medical Records</div>
                                <div><i className="fa fa-angle-right fa-2x text-secondary-angle " /></div>
                            </div>
                        </Link>
                    </div>

                    {/*<div className="col-md-6 col-lg-4 mb-4 list-container" >*/}
                    {/*    {enableRAF &&*/}
                    {/*        <div className="home-list-box" id="extole-home-refer">*/}
                    {/*            <div><img className="home-list-icons" src="/assets/images/icon_raf.svg" alt="Refer a Friend" /></div>*/}
                    {/*            <div className="home-list-title col-10" >Refer a Friend & Donate $25</div>*/}
                    {/*            <div><i className="fa fa-angle-right fa-2x text-secondary " /></div>*/}
                    {/*        </div>}*/}
                    {/*</div> */}
                    <div className="col-md-4 mb-4 d-none d-md-block list-container" >
                        <Link to={AppLinks.claims.claimStatus} >
                            <div className="home-list-box" >
                                <div><img className="home-list-icons claim-icon" src="/assets/images/icon-view-claim.svg" alt="View Claim Status" /></div>
                                <div className="home-list-title col-9" >View Claim Status</div>
                                <div><i className="fa fa-angle-right fa-2x text-secondary-angle " /></div>
                            </div>
                        </Link>
                    </div>

                    { (userDetails.Status.toLowerCase().trim() === "cancel prorata" ||
                        userDetails.Status.toLowerCase().trim() === "cancel full")?null:(<div className="col-md-4 mb-4 d-none d-md-block list-container">
                        <Link to={AppLinks.policy.addPet} >
                            <div className="home-list-box">
                                <div><img className="home-list-icons" src="/assets/images/icon-add-a-pet.svg" alt="Add a pet" /></div>
                                <div className="home-list-title col-9" >Add a Pet</div>
                                <div><i className="fa fa-angle-right fa-2x text-secondary-angle " /></div>
                            </div>
                        </Link>
                    </div>)}

                     {/* <div className="col-md-6 col-lg-4 mb-4 list-container" >
                        {enableRAF &&
                          
                            <a id="home-button"
                                    href={AppLinks.externalLinks.referAFriendCTA}
                                    target="_blank"
                                    track="button-refer-friend"
                                rel="noopener noreferrer">
                                <div className="home-list-box" >
                                    <div><img className="home-list-icons" src="/assets/images/icon-heart.svg" alt="Upload Medical Records" /></div>
                                    <div className="home-list-title col-9" >Refer a Friend</div>
                                    <div><i className="fa fa-angle-right fa-2x text-secondary-angle " /></div>
                                </div></a>
                            }
                    </div> */}
                    
                        {/* <div className="col-md-6 col-lg-4 mb-4 list-container" >
                            {enableRAF &&
                                <div className="home-list-box" id="extole-home-refer">
                                    <div><img className="home-list-icons" src="/assets/images/icon_raf.svg" alt="Refer a Friend" /></div>
                                    <div className="home-list-title col-10" >Refer a Friend & Donate $25</div>
                                    <div><i className="fa fa-angle-right fa-2x text-secondary " /></div>
                                </div>}
                        </div> */}
                        { (userDetails.Status.toLowerCase().trim() === "cancel prorata" ||
                        userDetails.Status.toLowerCase().trim() === "cancel full")?(<div className="col-md-4 mb-4 d-none d-md-block list-container"></div>): null}

                </div>

                <div className="links row d-flex flex-row flex-wrap justify-content-around" >
                    {/* <div className="d-flex flex-column justify-content-between col-md-4 mb-4 order-1 order-md-1">
                        <div className="content-wrapper">
                            <h2 className="text-primary-heading mb-0" > Pet Parent Information </h2>
                                { userDetails && userDetails.PetParentInfo &&
                                    <PetParentInfo
                                        parentInfo={userDetails.PetParentInfo}
                                        address={userDetails.PhysicalAddress}
                                        mailingAddress={userDetails.MailingAddress}
                                        reimbursement={userDetails.ClaimReimbursementMethod}
                                        policyEffectiveDate={userDetails.PolicyEffectiveDate}
                                        hidePassword={false}
                                        status ={userDetails.Status}
                                    />
                                }
                        </div>
                    </div> */}
                    <div id="airvet" className="d-flex flex-column justify-content-between col-md-4 mb-4 order-2 order-md-1">
                        <div className="content-wrapper">
                            <div className="airvet-white">
                                <div class="airvet-logo">
                                    <img src="/assets/images/airvet-logo.svg" alt="Airvet logo" />
                                </div>
                                <div className="subtitle1">Talk to a Vet Now</div>
                                <div className="subtitle2">24/7 virtual vet care is now included in your Healthy Paws policy!</div>
                                <p className="paratext">Connect with a licensed vet and avoid an in-person visit. Get support for everything from routine questions to urgent care.
                                </p>
                            </div>
                            <div className="airvet-blue">
                                <img src="/assets/images/airvet-Paw_Phone.svg" alt="Airvet Paw Phone image" className="blueSection-img" />
                                <button onClick={() => window.open('https://join.airvet.com/healthypaws')} className="blueSection-btn">
                                    Talk to a Vet Now
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex flex-column justify-content-between col-md-4 mb-4 order-1 order-md-2" >
                        <div className="content-wrapper p-0">
                            <ViewClaimStatusInfo
                                claimsDetails={claimsDetails}
                            />
                        </div>
                    </div>
                    <div className="d-flex flex-column justify-content-between col-md-4 mb-4 order-3">
                        <div className="content-wrapper">
                            <div style={{ textAlign: 'center', marginBottom: '15px'}}>
                                <img src="/assets/images/Logo_ GoodTrust.svg"></img>
                                <br />
                                
                            </div>
                            <div className="subtitle">Ensure your pet continues to live the life you imagine for them</div>
                        <br />
                        <br />
                        <p className="paratext"style={{marginTop: '-10px'}}>Choose a guardian, share their routines, vet info, and favorite treats—with a <a className="paratext-link"href="https://www.mygoodtrust.com/pet-directive" target="_blank" rel="noopener noreferrer">GoodTrust pet directive</a> you create a loving plan for their future. GoodTrust can also help you protect your entire family with wills, trusts and more.
                        </p>
                        <div style={{ backgroundColor: '#CEEBFC', padding: '10px', margin: '20px -20px' }}>
                            <span className="banner-text">Healthy Paws Offer: $10 off a Pet Directive</span>
                        </div>
                        <div style={{ backgroundColor: '#FCFAF4', padding: '20px', margin: '-22px -20px', textAlign: 'center', borderBottomLeftRadius : '10px', borderBottomRightRadius: '10px'}}>
                            <button onClick={() => window.open('https://mygoodtrust.com/pet-directive?promo=healthypaws10')} style={{border: '2px solid #008762',color: '#008762',padding: '10px 20px',borderRadius: '30px',fontWeight: '700',fontSize: '16px',backgroundColor: 'white',cursor: 'pointer'}}>
                                $10 Off a Pet Directive
                            </button>
                        </div>
                        </div>
                    </div>
                    <div className="d-md-flex flex-column justify-content-start col-md-4 mb-4 d-none order-4" >
                        <div className="link-list">
                            <div className="list-title" >My Account</div>
                            <Link to={AppLinks.account.viewProfile}><div className="list-content" >View Your Profile <span className="d-md-block" > <i className="fa fa-angle-right fa-2x text-secondary " /> </span></div></Link>
                            { (userDetails.Status.toLowerCase().trim() === "cancel prorata" ||
                                userDetails.Status.toLowerCase().trim() === "cancel full") ? null :(<Link to={AppLinks.account.changePhysicalAddress}><div className="list-content" >Change Physical Address <span className="d-md-block" > <i className="fa fa-angle-right fa-2x text-secondary " /> </span></div></Link>)}
                            <Link to={AppLinks.account.changeProfile}><div className="list-content" >Change Profile <span className="d-md-block" > <i className="fa fa-angle-right fa-2x text-secondary " /> </span></div></Link>
                            <Link to={AppLinks.account.changePassword}><div className="list-content" >Change Password <span className="d-md-block" > <i className="fa fa-angle-right fa-2x text-secondary " /> </span></div></Link>
                        </div>
                    </div>
                    <div className="d-md-flex flex-column justify-content-start col-md-4 mb-4 d-none order-5" >
                        <div className="link-list">
                            <div className="list-title" >Pet Policies</div>
                            <Link to={AppLinks.policy.viewPetDetails}><div className="list-content" >View Pet Details <span className="d-md-block" > <i className="fa fa-angle-right fa-2x text-secondary " /> </span></div></Link>
                            { (userDetails.Status.toLowerCase().trim() === "cancel prorata" ||
                                userDetails.Status.toLowerCase().trim() === "cancel full") ? null :(<Link to={AppLinks.policy.changePolicyOptions}><div className="list-content" >View Policy Options <span className="d-md-block" > <i className="fa fa-angle-right fa-2x text-secondary " /> </span></div></Link>)}
                            <Link to={AppLinks.policy.viewPolicyDocuments}><div className="list-content" >View Policy Documents <span className="d-md-block" > <i className="fa fa-angle-right fa-2x text-secondary " /> </span></div></Link>
                        </div>
                    </div>
                    <div className="d-md-flex flex-column justify-content-start col-md-4 mb-4 d-none order-6" >
                        <div className="link-list">
                            <div className="list-title" >Frequently Asked Questions</div>
                            <Link to={AppLinks.faq.planCoverageFAQ}><div className="list-content" >Plan Coverage FAQs <span className="d-md-block" > <i className="fa fa-angle-right fa-2x text-secondary " /> </span></div></Link>
                            <Link to={AppLinks.faq.policyManagementFAQ}><div className="list-content" >Policy Management FAQs <span className="d-md-block" > <i className="fa fa-angle-right fa-2x text-secondary " /> </span></div></Link>
                            <Link to={AppLinks.faq.submittingClaimsFAQ}><div className="list-content" >Submit Claims FAQs <span className="d-md-block" > <i className="fa fa-angle-right fa-2x text-secondary " /> </span></div></Link>
                            {/*{
                                
                                    enableRAF && <Link  to={AppLinks.faq.referAFriendFAQ}><div className="list-content" >Refer a Friend FAQs <span className="d-md-block" > <i className="fa fa-angle-right fa-2x text-secondary " /> </span></div></Link>
                                
                            }            */}                
                        </div>
                    </div>
                                
                </div>
                <div className="row disclaimer">
                    <div className="col-md-12">
                        <p className="ca-policy-disclaimer">
                            <span onClick={openPrivacyModal}>We protect your privacy</span>&nbsp;|&nbsp;
                            <span onClick={openCAModal}>CA Notice at Collection</span>
                        </p>
                    </div>
                    <ModalDialog
                        isOpen={isCAModalOpen}
                        modalHeader={"Healthy Paws Privacy Policy"}
                        toggle={closeCAModal}
                        modalBody={
                        <div className="d-flex flex-column">
                                   <CAPrivacyContent/>
                        </div>
                        }
                        modalFooter={
                             <a
                                className="button-primary-plusV2 close-button display-center"
                                style={{ borderRadius: '100px', height: '48px' }}
                                href="https://www.healthypawspetinsurance.com/FiledDocuments/Healthy%20Paws%20Privacy%20Policy.pdf"
                                target='_blank'
                            >
                                Download
                            </a>
                        }
                        className="modal-popup CA-discalimer"
                    />
                    <ModalDialog
                        isOpen={isPrivacyModalOpen}
                        modalHeader={"Healthy Paws Privacy Policy"}
                        toggle={closePrivacyModal}
                        modalBody={
                        <div className="d-flex flex-column">
                                   <PrivacyContent/>
                        </div>
                        }
                        modalFooter={
                            <a
                                className="button-primary-plusV2 close-button display-center"
                                style={{ borderRadius: '100px', height: '48px' }}
                                href="https://www.healthypawspetinsurance.com/FiledDocuments/Healthy%20Paws%20Privacy%20Policy.pdf"
                                target='_blank'
                            >
                                Download
                            </a>
                        }
                        className="modal-popup CA-discalimer"
                    />
                </div>
            </div>
            <LiveChat
                userAccountDetails={userDetails}
            />
        </div >
    )
}

export default Home;